define('uikit/mixins/component.mixin',['require','exports','module','underscore','backbone','jquery','./bind','./injector.mixin','../extra/rendering.manager','../config','../definitions/modules/transition'],function(require, exports, module){
  var _             = require('underscore');
  var Backbone      = require('backbone');
  var $             = require('jquery');
  var BindMixin     = require('./bind');
  var InjectorMixin = require('./injector.mixin');
  var renderer      = require('../extra/rendering.manager');
  var config        = require('../config');

  require('../definitions/modules/transition');


  var DISPLAY_REGEX = /display:[^;]*[ ]?[!]?(imporant|)[;]?/;

  function transitionExists() {
    var el = document.createElement('ui')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  $(function() {
    $.support.transition = transitionExists();
  });


  var ComponentMixin = _.extend({}, BindMixin, InjectorMixin, {

    normalizeMethods: Mn.normalizeMethods,

    // Component changes tagName depending on the link attribute
    allowTagChange: false,

    // when a component initializes, it needs to configure the component's dom element
    // to correctly reflect the state of the visible property.  If the visible
    // property matches the dom element's visibility then nothing is done.  If
    // it does not match then the corresponding show/hide needs to be called
    defaultDomElementVisibility: true,

    initialize: function() {
      var self = this;

      if (this._hasComponentInitialized) { return; }
      // allow the initialize to be called
      // twice
      this._hasComponentInitialized = true;

      // Binds and unbinds events based on collection change
      this._setupCollectionListeners();

      this.options       = this.options       || {};

      this.forceUpdate = _.extend({
        visible: false,
        model: false,
        collection: false
      }, this.forceUpdate);

      // bind mixins needs to run BEFORE the _initializeOptionProperties
      BindMixin.initialize.apply(this, arguments);

      // create an interal events that allows the component to internally respond
      // to changes of its own options.  setting these options using
      // this.option should only be used internally, and will
      // not trigger change events internally.  instead, change events will be
      // triggered externally.

      this._initializeOptionProperties();

      // injector mixin needs to run AFTER the _initializeOptionProperties
      InjectorMixin.initialize.apply(this, arguments);

      this._proxyInternalViewEvents();

      this.listenToOnce(this, 'before:destroy', this._onBeforeDestroy);
      this.listenTo(this,     'render',         this._onRender);
      this.listenToOnce(this, 'render',         this._initialComponentEvents);
      this.once('before:render', function() {
        this.triggerMethod('first:before:render', this);
      });
      this.once('render', function() {
        this.triggerMethod('first:render', this);
        this._updateDataNameAttribute();
        this.on('change:name', this._updateDataNameAttribute, this);
      }, this);

      if (this.options.visible !== false) {
        this.options.visible = true;
      }

      if (this.allowTagChange) {
        this._createLinkListener();
      }
    },

    setElement: function() {
      var ret = Mn.View.prototype.setElement.apply(this, arguments);
      if (this._hasSetupComponent === true) {
        this.updateElementVisibility();
      }
      return ret;
    },

    buildComponent: function(options) {
      options = _.extend({}, options, this.getInternalViewOptions(options.name));
      return this._injectorBuildComponent(options);
    },

    updateElementAttributes: function(attrs) {
      for (var attr in attrs) {
        this.el.setAttribute(attr, attrs[attr]);
      }
    },

    removeElementAttribute: function(attr) {
      this.el.removeAttribute(attr)
    },

    _proxyInternalViewEvents: function() {
      // setup dynamic event bindy stuff for internal views
      _.each(this.getInternalViews(), function(viewName) {
        var view = this[viewName];

        // Avoid setting up proxy multiple times for the same internal view
        if (!this._componentCanSetupProxy(viewName)) {
          return;
        }

        function callChildEvent(eventName) {
          var args        = _.rest(arguments),
              childEvents = this.normalizeMethods(_.result(this, 'childEvents'));

          if (typeof childEvents !== 'undefined' && _.isFunction(childEvents[eventName])) {
            childEvents[eventName].apply(this, args);
          }
        };

        this.proxyEventsFromOption(viewName, {
          callback: callChildEvent
        });

        this.on('change:' + viewName, function(self, current, previous) {
          view = this[viewName];
          if (view instanceof Backbone.View) {
            view._shouldCallShow = true;
          }
        }, this);


      }, this);
    },

    _componentCanSetupProxy: function(viewName) {
      this._internalViewProxy = this._internalViewProxy || [];

      if (this._internalViewProxy.indexOf(viewName) < 0) {
        this._internalViewProxy.push(viewName);
        return true;
      }

      return false
    },

    _updateDataNameAttribute: function() {
      var nameAttribute = config.externalizeViewName.nameAttribute;
      if (config.externalizeViewName.enabled) {
        if (this.getOption('name')) {
          this.$el.attr(nameAttribute, this.getOption('name'));
        } else {
          this.$el.removeAttr(nameAttribute);
        }
      }
    },

    proxyEventsFrom: function(bus, options) {
      options = options || {};
      var prefix = options.withPrefix ? options.withPrefix + ':' : '',
          self   = this;

      function triggerEvent(eventName) {
        var proxyName = prefix + eventName,
            args      = [proxyName].concat(options.args || []).concat(_.rest(arguments));

        this.triggerMethod.apply(this, args);
        if (options.callback) {
          options.callback.apply(this, args)
        }
      }

      this.listenTo(bus, 'all', triggerEvent);

      return _.once(function() {
        self.stopListening(bus, 'all', triggerEvent);
      })
    },

    proxyEventsFromOption: function(optionName, options) {
      var bus, unbind = _.noop;
      function doProxy() {
        unbind();
        bus = this[optionName];
        // check if the event bus is in fact
        // an event bus
        if (bus && bus.listenTo) {
          unbind = this.proxyEventsFrom(bus, _.extend({
            withPrefix: optionName,
            args: [bus]
          }, options))
        }
      }
      this.on('change:' + optionName, doProxy, this);
      doProxy.call(this);
      return this;
    },

    bindOption: function(optionName, targetOptionName, targetView) {
      targetView[targetOptionName] = this[optionName];
      this.on('change:' + optionName, function() {
        targetView[targetOptionName] = this[optionName];
      }, this);
      this.listenTo(targetView, 'change:' + targetOptionName, function() {
        this[optionName] = targetView[targetOptionName];
      });
      return this;
    },

    _doesKeyChangeNeedReRender: function(key, value) {
      return this.forceUpdate[key] === true;
    },

    _initialComponentEvents: function() {
      this._hasSetupComponent = true;

      this.on('change', function(model, key, value, previous, options) {
        options || (options = {});
        if (options.internal === true) {
          // we don't need to update if the change came from an internal
          // setting
          return;
        }
        if (!this._needsReRender) {
          this._needsReRender = this._doesKeyChangeNeedReRender(key, value);
        }
        renderer.requestRender(_.bind(this._updateComponent, this), this.cid);
      });

      this.on('change:visible', function(view, newValue, oldValue, options) {
        if (!options || !options.internalVisibilityAction) {
          this.updateElementVisibility();
        }
      }, this);
      var defaultVisible = this.visible === false ? false : true;
      if (defaultVisible !== this.getOption('defaultDomElementVisibility')) {
        if (this.getOption('defaultDomElementVisibility')) {
          // the DOM element defaults to being visible so hide
          this.hide({ force: true });
        } else {
          // the DOM element defaults to be hidden so show
          this.show({ force: true });
        }
      }

      // Initial internal views render
      this._injectorUpdateInternalViews();
    },

    updateElementVisibility: function() {
      // Need to invert visible property so when
      // show/hide checks it to make sure it should actually
      // show and hide, it will changes the elements visibility
      // instead of just returning
      if (this.visible) {
        this.show({ force: true });
      } else {
        this.hide({ force: true });
      }
    },

    _requestRender: function() {
      if (!this.isRendered) { return; }
      this._needsReRender = true;
      renderer.requestRender(_.bind(this._updateComponent, this), this.cid);
    },

    _updateComponent: function() {
      if (!this._disableChange && !this.isDestroyed) {
        if (!this._isRendered && !this.isRendered && !this.visible) {
          //if we aren't visible and we've never rendered.. don't even bother
          return;
        }
        if (this._needsReRender) {
          this.render();
        } else {
          this.clearClassNames();
          this.updateAttributes();
        }
      }
      this._needsReRender = false;
    },

    _ensureElement: function() {
      if (this.allowTagChange) {
        this._verifyLink();
      }

      Backbone.View.prototype._ensureElement.apply(this, arguments);
    },

    _verifyLink: function() {
      var options  = this.options,
          bindings = _.extend({},this.bindings, options.bindings);

      // Cache the original tag name
      if (!this._originalTagName) {
        this._originalTagName = this.tagName;
      }

      if (options.link || this.link) {
        this.tagName = 'a';
      } else if (options.model && bindings && bindings.link && options.model.get(bindings.link)) {
        this.tagName = 'a';
      } else {
        this.tagName = this._originalTagName;
      }
    },

    _createLinkListener: function() {
      this.on('change:link', function(self, link, oldLink) {
        // Only proceed if link exists and previously didn't, or vice versa
        if (!!link != !!oldLink) {
          var oldEl = this.$el;

          // Undelegate events on the previous element
          this.undelegateEvents();

          // Clear the current element
          this.el = null;

          // Create new element based on the new attributes
          this._ensureElement();

          // Replace on the dom the old element with the new one
          oldEl.replaceWith(this.$el);

          this._requestRender();
        }
      }, this);
    },

    _isVisible: function() {
      return this.$el.is(":visible");
    },

    _setOption: function(key, value, options) {
     this._setProperty(key, value, options, 'options')
    },

    _setProperty: function(key, value, options, namespace) {
       var change  = false,
          oldValue = this[namespace][key];

      if (_.isBoolean(options)) {
        // added in purely for legacy support...
        // doesn't do anything but leaving it in until
        // old code is removed
        options = { external: options };
      }

      options = _.extend({}, options, {
        previousValue: this[namespace][key]
      });

      // check if a change event need to be fired
      if (this[namespace][key] !== value) {
        change = true;
      }
      // change actual value
      this[namespace][key] = value;
      // trigger events
      if (change) {
        // One of our options is an internal view and we are removing it.  Make
        // sure we unbind any and all events on that view.
        if (oldValue && oldValue._listenId && _.contains(this._internalViews, key)) {
          this.stopListening(oldValue);
        }

        if (options.silent !== true) {
          this.triggerMethod("change:" + key, this, value, oldValue, options);
          this.triggerMethod("change", this, key, value, oldValue, options);
        }
      }
    },

    _initializeOptionProperties: function() {
      var self = this;

      var keys = _.keys(this.options);
      this._definedOptionPropertyKeys = keys;
      if (_.indexOf(keys, 'visible') < 0) {
        keys.push('visible');
      }
      if (_.indexOf(keys, 'model') < 0) {
        keys.push('model');
      }
      if (_.indexOf(keys, 'collection') < 0) {
        keys.push('collection');
      }
      _.each(this._internalViews, function(key) {
        if (_.indexOf(keys, key) < 0) {
          keys.push(key);
        }
      });

      _.each(keys, function(key) {
        this._initializeProperty(key, 'options');
      }, this);
    },

    _initializeProperty: function(name, namespace) {
      var self                    = this,
          definedOptionProperties = this._definedOptionProperties || (this._definedOptionProperties = {});

      if (definedOptionProperties[name]) { return this; }

      this._initializePropertyValue(name, namespace);

      definedOptionProperties[name] = true;

      Object.defineProperty(this, name, {
        configurable: true,
        get: function() {
          return self[namespace][name];
        },
        set: function(value) {
          self._setProperty(name, value, false, namespace);
          return self;
        }
      });
      return this;
    },

    _freezeProperty: function(name, namespace) {
      var self = this;
      var definedOptionProperties = this._definedOptionProperties || (this._definedOptionProperties = {});

      this._initializePropertyValue(name, namespace);

      delete definedOptionProperties[name];

      Object.defineProperty(this, name, {
        configurable: true,
        writable: false,
        value: this[namespace][name]
      });
      return this;
    },

    _unfreezeProperty: function(name, namespace) {
      this._initializeProperty(name, namespace);
      return this;
    },

    _initializePropertyValue: function(name, namespace) {
      var definedOptionProperties = this._definedOptionProperties || (this._definedOptionProperties = {});

      if (definedOptionProperties[name]) { return this; }

      this[namespace] || (this[namespace] = {});

      if (this[namespace][name] == null && this[name] != null) {
        // if the current value on this is defined
        // but the options is not defined then pass
        // the value down to the options
        this[namespace][name] = this[name];
      }
      return this;
    },

    show: function(options) {
      var animation = false;
      if (_.isString(options)) {
        animation = options;
        options = {};
      }
      options = _.extend({ queue: false, animation: animation }, options);
      // only run this code if we are not visible and need to show
      if (!this.visible || options.force === true) {

        this._show(options);
      }
      this._setOption('visible', true, { internalVisibilityAction: true })
      return this;
    },

    _show: function(options) {
      // if we are doing an animation then use the transition logic
      if (options.animation && $.support.transition) {
        if (_.isBoolean(options.animation)) {
          options.animation = 'fade in';
        }
        if (options.animation.indexOf('in') < 0) {
          options.animation = options.animation.trim() + ' in';
        }
        this._transition(options);
      } else {
        // if we have done an animation before then we need to do
        // very special logic to show the element properly
        if (this._hasTransitioned) {
          var style = (this.$el.attr('style') || '').replace(DISPLAY_REGEX, '');
          this.$el.attr('style', style).removeClass('hidden');
        } else {
          this.el.style.display = '';
        }
        if (options.onComplete) {
          options.onComplete.call(this.$el);
        }
      }
    },

    hide: function(options) {
      var animation = false;
      if (_.isString(options) || _.isBoolean(options)) {
        animation = options;
        options = {};
      }
      options = _.extend({ queue: false, animation: animation }, options);
      // only run this code if we are viisble and need to hide
      if (this.visible || options.force === true) {
        this._hide(options);
      }
      this._setOption('visible', false, { internalVisibilityAction: true });
      return this;
    },

    _hide: function(options) {
      // only do animation if we specify one
      if (options.animation && $.support.transition) {
        if (_.isBoolean(options.animation)) {
          options.animation = 'fade out';
        }
        if (options.animation.indexOf('out') < 0) {
          options.animation = options.animation.trim() + ' out';
        }
        this._transition(options);

      } else {
        // if we have done an animation before then we need to do
        // very special logic to hide the element properly
        if (this._hasTransitioned) {
          var style = (this.$el.attr('style') || '').replace(DISPLAY_REGEX, '');
          style += ' display: none;';
          this.$el.attr('style', style).removeClass('visible');
        } else {
          this.el.style.display = 'none';
        }
        if (options.onComplete) {
          options.onComplete.call(this.$el);
        }
      }
    },

    _transition: function(options) {
      this._hasTransitioned = true;
      this.$el.transition(options);
    },

    _onRender: function() {
      this._proxyInternalViewEvents();

      this.clearClassNames();
      this.updateAttributes();
    },

    updateAttributes: function() {

    },

    clearClassNames: function() {
      var cache = this._classNameCache || [];
      for (var i = 0, len = cache.length, className; i < len; i++) {
        className = cache[i];
        this.$el.removeClass(className);
      }
      this._classNameCache = [];
      return this;
    },

    addClass: function(className, shouldAdd) {
     var cache     = this._classNameCache || (this._classNameCache = []);

      shouldAdd = arguments.length > 1 ? shouldAdd : true;

      if (shouldAdd === true) {
        cache.push(className);
        this.el.className += (' ' + String(className).trim());
      }

      return this;
    },

    getBoolOption: function(name) {
      return !!this.getOption(name);
    },

    serializeData: function() {
      var data = _.extend({}, this.options);

      // TODO - deal with the implications of this being a mixin...
      // is this ok to leave like this?
      if (this.model && this.serializeModel) {
        data.model = this.serializeModel(this.model);
      }
      if (this.collection && this.serializeCollection) {
        data.items = this.serializeCollection(this.collection);
      }

      return data;
    },

    // do nothing...just here so we have something to register
    onFirstRender: function() {},

    _onBeforeDestroy: function() {
    },

    serializeOptions: function() {
      var options = {};

      _.each(this._definedOptionPropertyKeys, function(key) {
        var value = this.getOption(key);
        if (_.isString(value) || _.isBoolean(value)) {
          options[key] = value;
        }
      }, this);

      return options;
    },

    _setupBindings: function() {
      var model    = this.model,
          bindings = this.getOption('bindings') || {},
          ev       = this._createBindingsEventObject(),
          self     = this;

      _.each(bindings, function(modelField, viewField) {
        self._bindBinding(ev, self, viewField, model, modelField);
      });

      BindMixin._setupBindings.apply(this, arguments);
    },

    _createBindingsEventObject: function() {
      var prevEv = this._previousEventBus,
          ev     = _.extend({}, Backbone.Events);

      // Ensure previous event handler is no longer being used
      if (prevEv) {
        prevEv.stopListening();
      }

      ev
        .listenTo(this, 'change:model', function(self, newModel) {
          ev.stopListening();

          self._setupBindings();
        })
        .listenTo(this, 'before:destroy', function() {
          ev.stopListening();
        });

      this._previousEventBus = ev;

      return ev;
    },

    // ev is the events object
    _bindBinding: function(ev, view, viewField, model, modelField) {
      // we don't want to bind on properties that map to nothing
      // setting null disables the binding
      if (modelField == null || viewField == 'model') { return; }

      if (!(view instanceof Backbone.View)) { return; }

      if (!model) {
        view[viewField] = null;
        return;
      }

      var shouldInvertValue = false;
      if (String(viewField)[0] == '!') {
        viewField = String(viewField).slice(1);
        shouldInvertValue = true;
      }
      if (String(modelField)[0] == '!') {
        modelField = String(modelField).slice(1);
        shouldInvertValue = true;
      }

      ev
        .listenTo(model, 'change:' + modelField, function() {
          if (shouldInvertValue) {
            view[viewField] = !model.get(modelField);
          } else {
            view[viewField] = model.get(modelField);
          }
        })
        .listenTo(view, 'change:' + viewField, function() {
          if (shouldInvertValue) {
            model.set(modelField, !view[viewField]);
          } else {
            model.set(modelField, view[viewField]);
          }
        });

        if (shouldInvertValue) {
          view[viewField] = !model.get(modelField);
        } else {
          view[viewField] = model.get(modelField);
        }
    },

    /**
     *  When the collection changes after the view is instantiated,
     *  unbind events on the previous collection and
     *  bind events on the new collection
     */
    _setupCollectionListeners: function() {
      this.listenTo(this, 'change:collection', function(self, value, oldValue) {

        // Initial binding is done after the view is rendered the first time
        // Changes
        if (this._hasSetupComponent) {
          // Stop listening to the previous collection
          if (oldValue) {
            this.stopListening(oldValue);
          }

          // Rebind initial marionette events on the collection
          if (this.constructor.prototype._initialEvents) {
            this.constructor.prototype._initialEvents.apply(this);
          }

          if (this._renderChildren) {
            // if component is setup then we need to re-render the
            // children since the collection has changed
            this._renderChildren();
          }
        }

        // Unbind collectionEvents on the previous collection
        this.undelegateCollectionEvents(oldValue);

        // Bind collecitonEvents on the new collection
        this.delegateCollectionEvents(value);
      })
    },

    delegateCollectionEvents: function(collection) {
      this.bindEntityEvents(collection, this.getOption('collectionEvents'));

      _.each(this._behaviors, function(behavior) {
        behavior.bindEntityEvents(collection, behavior.getOption('collectionEvents'));
      }, this);

      return this;
    },

    undelegateCollectionEvents: function(collection) {
      this.unbindEntityEvents(collection, this.getOption('collectionEvents'));

      _.each(this._behaviors, function(behavior) {
        behavior.unbindEntityEvents(collection, behavior.getOption('collectionEvents'));
      }, this);

      return this;
    }

  });

  module.exports = ComponentMixin;
});

